import { decoratedCa } from 'shared/mf-infrastructure/utils/analytics';

export function trackCollapseMapServices(objectType: string | null, profile: string | null) {
  decoratedCa('eventSite', {
    action: 'click_sopr',
    category: 'Infrastructure',
    label: 'collapse block',
    name: 'oldevent',
    page: {
      extra: {
        profile,
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
